export default __webpack_public_path__ + "static/media/sanmar4.fa7532bf.jpg";